import { authentificationRepository } from '../repositories/authentication-repository';

async function signOut() {
    return authentificationRepository.signOut();
}

export {
    signOut
};
